// extracted by mini-css-extract-plugin
export default {"container":"tZ-z","list":"uZ-z"};